import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";
import { TechnicianPerformanceFragment } from "../../fragments/technicianPerformanceFragment";

// Common Fragments
import {
	AddedCompensationFragment,
	CompensationFragment,
	EmployeeFragment,
	LongevityFragment,
	ReviewFragment,
	TechnicianSpiffsFragment,
} from "@/Washouts/api/common/fragments";

export const getTechniciansWashout = async (...params) => {
	const [locationId, userId, commissionCycleId, payPeriodId, position] = params;

	const query = gql`
		query getTechniciansWashout(
			$locationId: String!
			$userId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$position: String!
		) {
			getTechniciansWashout(
				locationId: $locationId
				userId: $userId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				position: $position
			) {
				_id
				userId
				commissionCycleId
				payPeriodId
				created
				employee {
					...Employee
				}
				flaggedTimePerformance {
					...TechnicianPerformance
				}
				pendingRepairOrders {
					...TechnicianPerformance
				}
				spiffs {
					...Spiffs
				}
				longevity {
					...Longevity
				}
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${TechnicianPerformanceFragment}
		${AddedCompensationFragment}
		${CompensationFragment}
		${EmployeeFragment}
		${LongevityFragment}
		${ReviewFragment}
		${TechnicianSpiffsFragment}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		userId,
		payPeriodId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getTechniciansWashout;
	} catch (error) {
		errorLogger(error);
		return null;
	}
};

export async function getTechniciansWashoutReview(...params) {
	const [location, commissionCycle, payPeriodId = null, position] = params;
	const query = gql`
		query getTechniciansWashout($locationId: String!, $commissionCycleId: String!, $payPeriodId: String, $position: String!) {
			getTechniciansWashout(
				commissionCycleId: $commissionCycleId
				locationId: $locationId
				payPeriodId: $payPeriodId
				position: $position
			) {
				_id
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
	const variables = {
		locationId: location,
		commissionCycleId: commissionCycle,
		payPeriodId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getTechniciansWashout;
	} catch (error) {
		errorLogger(error);
		return null;
	}
}
